import 'react'
import { useMutation } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'

export const updateLeadTimes = async (updateLeadTimes) => {
  const { id, ...changedFields } = updateLeadTimes

  if (!id) throw 'No Id Supplied'
  //MAKING THE UPDATE API CALL
  const updateLeadTimesAPIPath = `${API_URL}/api/leadTimes/v1/update/${id}`
  const res = await axios.patch(updateLeadTimesAPIPath, changedFields)
  return res.data
}

export function useUpdateLeadTimes() {
  return useMutation(updateLeadTimes)
}

export const addLeadTimes = async (newItem) => {
  const addLeadTimesAPIPath = `${API_URL}/api/leadTimes/v1/new`
  return await axios.post(addLeadTimesAPIPath, newItem)
}

export function useAddLeadTimes() {
  return useMutation(addLeadTimes)
}

export const deleteLeadTimes = async ({ id }) => {
  if (!id) throw 'Supply Id to delete'
  const deleteLeadTimesAPIPath = `${API_URL}/api/leadTimes/v1/${id}`
  return await axios.delete(deleteLeadTimesAPIPath)
}

export function useDeleteLeadTimes() {
  return useMutation(deleteLeadTimes)
}
